import React, { useEffect, useRef, useState } from 'react';

// Scales its children uniformly so they fit entirely inside the available space —
// used for beamer/TV displays where content must never scroll or clip.
export default function FitToScreen({ children, maxScale = 3, className = '' }) {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return;

    const recalc = () => {
      const cw = container.clientWidth;
      const ch = container.clientHeight;
      const contentWidth = content.scrollWidth;
      const contentHeight = content.scrollHeight;
      if (!cw || !ch || !contentWidth || !contentHeight) return;
      setScale(Math.min(cw / contentWidth, ch / contentHeight, maxScale));
    };

    recalc();
    const ro = new ResizeObserver(recalc);
    ro.observe(container);
    ro.observe(content);
    return () => ro.disconnect();
  }, [children, maxScale]);

  return (
    <div ref={containerRef} className={`relative w-full h-full flex items-center justify-center overflow-hidden ${className}`}>
      <div ref={contentRef} style={{ transform: `scale(${scale})`, transformOrigin: 'center center' }}>
        {children}
      </div>
    </div>
  );
}
